//  TODO: move to features store
export class Features {
  public static isBugsnagEnabled(): boolean {
    return PROJECT_CONFIG.features.bugsnag || false;
  }

  public static isUserDeepLinkEnabled(): boolean {
    return PROJECT_CONFIG.features.userDeepLink || false;
  }

  public static isSpacesEnabled(): boolean {
    return PROJECT_CONFIG.features.spaces || false;
  }

  public static isCatalogEnabled(): boolean {
    return PROJECT_CONFIG.features.catalog || false;
  }

  public static isNewsfeedEnabled(): boolean {
    return PROJECT_CONFIG.features.newsfeed || false;
  }

  public static isHubEnabled(): boolean {
    return PROJECT_CONFIG.features.hub || false;
  }

  public static isMarketplaceEnabled(): boolean {
    return PROJECT_CONFIG.features.marketplace || false;
  }

  public static isUnionCallEnabled(): boolean {
    return PROJECT_CONFIG.features.unionCall;
  }

  public static isArticleEnabled(): boolean {
    return PROJECT_CONFIG.features.article || false;
  }

  public static isSendFeedbackEnabled(): boolean {
    return PROJECT_CONFIG.features.feedback || false;
  }

  public static isDeleteForMeEnabled(): boolean {
    return PROJECT_CONFIG.features.deleteForMe || false;
  }

  public static isVoiceTranscriptionEnabled(): boolean {
    return PROJECT_CONFIG.features.voiceTranscription || false;
  }

  public static isMessageTranslateEnabled(): boolean {
    return PROJECT_CONFIG.features.messageTranslate || false;
  }

  public static isBotEnabled(): boolean {
    return PROJECT_CONFIG.features.bot || false;
  }

  public static isChannelCategoryChoiceEnabled(): boolean {
    return PROJECT_CONFIG.features.channelCategory || false;
  }

  public static isStreamsEnabled(): boolean {
    return PROJECT_CONFIG.features.streams || false;
  }

  public static isFlexibleCallEnabled(): boolean {
    return PROJECT_CONFIG.features.flexibleCall || false;
  }

  public static isBanUserEnabled(): boolean {
    return PROJECT_CONFIG.features.banUser || false;
  }

  public static isContactsEnabled(): boolean {
    return PROJECT_CONFIG.features.contacts || false;
  }

  public static isMonetizationEnabled(): boolean {
    return PROJECT_CONFIG.features.monetization || false;
  }

  public static isOpenChatEnabled(): boolean {
    return PROJECT_CONFIG.features.createOpenChat || false;
  }

  public static isScheduledMessagesEnabled(): boolean {
    return PROJECT_CONFIG.features.scheduledMessages || false;
  }

  public static isThreadsEnabled(): boolean {
    return PROJECT_CONFIG.features.threads || false;
  }

  public static isLocationMessagesEnabled(): boolean {
    return PROJECT_CONFIG.features.locationMessages || false;
  }

  public static isReportsEnabled(): boolean {
    return PROJECT_CONFIG.features.reports || false;
  }

  public static isOnboardingEnabled(): boolean {
    return PROJECT_CONFIG.features.onboarding || false;
  }

  public static isPermissionsGroupEnabled(): boolean {
    return PROJECT_CONFIG.features.permissionsGroup || false;
  }

  public static isPermissionsSpaceEnabled(): boolean {
    return PROJECT_CONFIG.features.permissionsSpace || false;
  }

  public static isUserGiftsEnabled(): boolean {
    return PROJECT_CONFIG.features.userGifts || false;
  }

  public static isScheduledCallEnabled(): boolean {
    return PROJECT_CONFIG.features.scheduledCall || false;
  }

  public static isVerifiedBadgeEnabled(): boolean {
    return PROJECT_CONFIG.features.verifiedBadge || false;
  }

  public static isLogEnabled(): boolean {
    return PROJECT_CONFIG.features.isLogEnabled || false;
  }

  public static isMarkGroupAsReadUnreadEnabled(): boolean {
    return PROJECT_CONFIG.features.markGroupAsReadUnread || false;
  }

  public static isDraftInputEnabled(): boolean {
    return PROJECT_CONFIG.features.draftInput || false;
  }

  public static isPrivacySettingsEnabled(): boolean {
    return false;
  }

  public static isChannelDeepLinkEnabled(): boolean {
    return false;
  }

  public static isStickerDeepLinkEnabled(): boolean {
    return PROJECT_CONFIG.features.stickerDeepLink || false;
  }

  public static isRefreshDeeplinkEnabled(): boolean {
    return PROJECT_CONFIG.features.refreshDeepLink || false;
  }

  public static isProxyEnabled(): boolean {
    return PROJECT_CONFIG.features.isProxyEnabled || false;
  }
}
